<template>
  <span>
    <!--<img v-if="stopped" :src="selectBall" name="slide">
    <img v-else :src="img" name="slide">-->
    <img :src="img" name="slide">
  </span>
</template>
<script>
export default {
  name: 'SlotNumber',
  props: {
    select: {
      type: [Number, String],
      default: null
    },
    timeout: {
      type: Number,
      default: 10
    },
    start: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      stopped: false,
      Interval: null,
      setTimeout: null,
      number: 0
    }
  },
  computed: {
    img() {
      let random = (Math.floor(Math.random() * 10) % 4)
      let number = (this.number * 4) + random
      let select = (this.select * 4) + 2

      if(this.stopped) {
        return require(`@/assets/theme/balls/${select.toString()}.png`)
      }else{
        return require(`@/assets/theme/balls/${number.toString()}.png`)
      }
    },
    selectBall() {
      let select = (this.select * 4) + 2
      return require(`@/assets/theme/balls/${select.toString()}.png`)
    }
  },
  watch: {
    select() {
      if(this.select !== null) {
        this.processTimeout()
      }else{
        this.stopped = false
        this.spinning()
      }
    }
  },
  methods: {
    spinning() {
      let running = this.start
      clearInterval(this.Interval)
      this.Interval = setInterval(() => {
        running++;
        this.number = running % 10
      }, 100);
    },
    processTimeout() {
      let timeout = this.timeout < 0 ? (6-this.start)*1000 : this.timeout
      this.setTimeout = setTimeout(()=>{
        if(this.select!==null){
          this.stopped = true
          clearInterval(this.Interval)
        }
      }, timeout)
    }
  },
  mounted() {
    this.spinning()
    this.processTimeout()
  },
  beforeDestroy() {
    clearInterval(this.Interval)
    clearTimeout(this.setTimeout)
  }
}
</script>
